import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const sectionHeadingDefaultVariants = {}
const sectionHeadingCompoundVariants = []

const sectionHeadingSlotNames = [
  [
    "root",
    "section-heading__root"
  ],
  [
    "top",
    "section-heading__top"
  ],
  [
    "bottom",
    "section-heading__bottom"
  ],
  [
    "title",
    "section-heading__title"
  ],
  [
    "intro",
    "section-heading__intro"
  ]
]
const sectionHeadingSlotFns = /* @__PURE__ */ sectionHeadingSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, sectionHeadingDefaultVariants, getSlotCompoundVariant(sectionHeadingCompoundVariants, slotName))])

const sectionHeadingFn = memo((props = {}) => {
  return Object.fromEntries(sectionHeadingSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const sectionHeadingVariantKeys = []
const getVariantProps = (variants) => ({ ...sectionHeadingDefaultVariants, ...compact(variants) })

export const sectionHeading = /* @__PURE__ */ Object.assign(sectionHeadingFn, {
  __recipe__: false,
  __name__: 'sectionHeading',
  raw: (props) => props,
  variantKeys: sectionHeadingVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, sectionHeadingVariantKeys)
  },
  getVariantProps
})